import { SubAccount } from '../../api/services/dd_panel_sub_accounts/types.ts'
import Recommendation from '../../components/subAccounts/Recommendation'
import ToggleSurvey from '../../components/subAccounts/ToggleSurvey'

export const setSubAccountsTableColumns = (allAccs: SubAccount[] | null) => {
  const styles = (isActive: boolean) =>
    `inline-flex rounded-full bg-opacity-10 dark:bg-opacity-50 dark:text-white 0 py-1 px-6 text-sm font-medium ${isActive ? 'bg-green-500 text-green-800' : 'bg-red-500 text-red-800'}`

  return [
    {
      header: 'Email konta',
      accessor: 'user_email',
      render: (row: SubAccount) => <>{row.user_email}</>,
      className: 'text-center w-[240px] py-6'
    },
    {
      header: 'Konto',
      accessor: 'groups',
      render: (row: SubAccount) => {
        const isRestricted = row.user_groups.includes(
          'dd_panel_restricted_users'
        )
        return (
          <p className={styles(!isRestricted)}>
            {isRestricted ? 'Nieopłacone' : 'Opłacone'}
          </p>
        )
      },
      className: 'text-center w-[150px]'
    },
    {
      header: 'Konto Stripe',
      accessor: 'onboarding_completed',
      render: (row: SubAccount) => (
        <p className={styles(row.onboarding_completed)}>
          {row.onboarding_completed ? 'Aktywne' : 'Nieaktywne'}
        </p>
      ),
      className: 'text-center w-[150px]'
    },
    {
      header: 'Polecający',
      accessor: 'recommender_email',
      render: (row: SubAccount) => (
        <Recommendation rowEdited={row} allAccounts={allAccs} />
      ),
      className: 'text-center w-[220px]',
    },
    {
      header: 'Dostęp do ankiet',
      accessor: 'surveys_enabled',
      render: (row: SubAccount) => <ToggleSurvey row={row} />,
      className: 'text-center w-[150px]'
    }
  ]
}
